import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface ChargePointsNameCellProps
  extends CellContext<
    GatewayChargePointInMaintenanceModel,
    GatewayChargePointInMaintenanceModel['name']
  > {}

export const ChargePointsNameCell = (
  props: ChargePointsNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const navigate = useNavigate();
  const {
    row: { original: chargePoint },
    getValue,
  } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.CHARGE_POINT.DETAILS, { id: chargePoint.id }),
        )
      }
      fullWidth>
      <Text truncate>{getValue()}</Text>
    </Link>
  );
};
